import Vue from 'vue'
import Router from 'vue-router'
// import routes from './routes/'
import {logged, guest} from './middleware'

// Components
import Home from '@/components/views/Home'
import Login from '@/components/views/Login'
import Logout from '@/components/actions/Logout'
import Presence from '@/components/views/Presence'
import Warehouses from '@/components/views/warehouses/Warehouses'
import AddProducts from '@/components/views/warehouses/AddProducts'

Vue.use(Router)

/**
 * Makes a new VueRouter that we will use to run all of the routes for the app.
 */

const router = new Router({
// export default new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/employees/signs',
      name: 'Presence',
      component: Presence
    },
    {
      path: '/warehouses',
      name: 'Warehouses',
      component: Warehouses
    },
    {
      path: '/warehouses/:id/products/add',
      name: 'AddProducts',
      component: AddProducts
    }
  ]
})

// Add middleware to each route
router.beforeEach((to, from, next) => {
  // Paths of a specific role
  // role(to, from, next)
  // Auth required
  logged(to, from, next)
  // Guest paths
  guest(to, from, next)
  // Default
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js